import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import { MdOutlineNavigateBefore } from "react-icons/md";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
const My_ads = () => {
  const [myProducts, setMyProducts] = useState([]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);
  const handleRefresh = () => {
    window.location.reload(); // or refetch data logic
  };

  useEffect(() => {
    fetchAds();
  }, []);

  const fetchAds = async () => {
    try {
      const token = localStorage.getItem("token");
      const userId = JSON.parse(localStorage.getItem("user"))?._id;
      const res = await axios.get(
        "https://network.rentel.in/products/get-user-products",
        {
          params: { userId },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMyProducts(res.data?.products || []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  const handleDelete = async (productId) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return alert("You must be logged in to delete products.");

      setIsDeleting(true);

      const res = await axios.delete("https://network.rentel.in/products/delete", {
        headers: { Authorization: `Bearer ${token}` },
        params: { productId: productId, isHardDelete: true },
      });

      if (res?.data?.success) {
        // Remove product from list immediately
        setMyProducts((prev) => prev.filter((ad) => ad._id !== productId));
      } else {
        alert(res?.data?.message || "Failed to delete the product.");
      }
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete the product. Please try again.");
    } finally {
      // Hide loader after a small delay to ensure smooth transition
      setTimeout(() => {
        setIsDeleting(false);
      }, 300);
    }
  };

  const handleNavigateEditPage = (product) => {

    const category = product.category;
    // console.log(category);
    const subCategory = product?.subCategory || "";
    const path = subCategory
      ? `/Add-Product/${encodeURIComponent(category)}/${encodeURIComponent(
        subCategory
      )}`
      : `/Add-Product/${encodeURIComponent(category)}/`;

    // Mark edit mode for refresh-safe entry
    // sessionStorage.setItem("isEditMode", "true");
    // Navigate to edit page with product ID and flags
    // console.log(path);
    navigate(path, {
      state: {
        product: product,
        isEditMode: true,
        productId: product._id,
        categoryId: product?.categoryId || '',
      },
    });
  }

  const calculateDiscountedPrice = (price, discount) =>
    discount > 0 ? price - (price * discount) / 100 : price;

  const capitalizeWords = (text = "") =>
    text
      .split(" ")
      .map(word =>
        word
          ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          : ""
      )
      .join(" ");


  return (
    <>
      {/* Loader Overlay for Delete */}
      {isDeleting && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(173, 173, 173, 0.65)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}
          >
            {[0, 1, 2, 3, 4].map((index) => (
              <div
                key={index}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: "#E91E63",
                  animation: `bounce 1.4s ease-in-out ${index * 0.2}s infinite both`,
                }}
              />
            ))}
          </div>
          <style>
            {`
              @keyframes bounce {
                0%, 80%, 100% {
                  transform: scale(0);
                  opacity: 0.5;
                }
                40% {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            `}
          </style>
        </div>
      )}
      {/* -=-=-=-=destop view=-=-=-=- */}
      <NoZoomWrapper>
        <NoCopyWrapper>
          <div className="container">
            <div className="desktop-view">
              <Header />
              {/* <Menu /> */}
              <div className="df-note">
                <div className="todo">
                  <MdOutlineNavigateBefore
                    className="befor-btn"
                    onClick={() => navigate("/")}
                  />
                  <h3 className="back">{t("manageProducts")}</h3>
                </div>
                <p className="total-item">
                  {t("myTotalProducts")} {myProducts.length}
                </p>
              </div>

              <div className="bodo">
                {myProducts.length === 0 ? (
                  <div className="empty-center">
                    <h4>No Products</h4>
                  </div>
                ) : (
                  myProducts.map((product) => (
                    <div className="pro-card" key={product._id}>
                      <div className="image-containere">
                        <Link
                          to={`/${product.category}/${product.subCategory}/${encodeURIComponent(
                            product.title
                          )}`}
                          state={{ productId: product._id }}
                        >
                          <img
                            src={product.images?.[0] || "/fallback.jpg"}
                            alt={product.title}
                          />
                        </Link>
                      </div>

                      <div className="all-ad">
                        <p className="originale-priceo">
                          {`${product.userId?.name || ""} ${product.userId?.lastName || "Unknown Seller"
                            }`}
                        </p>

                        <div className="sprat">
                          <h3>{capitalizeWords(product.title)}</h3>
                        </div>

                        <p className="price-discount">
                          <span className="final-priceoe">
                            ₹
                            {calculateDiscountedPrice(
                              product.price,
                              product.discount
                            ).toLocaleString("en-IN")}
                          </span>

                          {product.discount > 0 && (
                            <>
                              <span className="original-priceo">
                                ₹{product.price.toLocaleString("en-IN")}
                              </span>{" "}
                              | <span className="discounte">{product.discount}% OFF</span>
                            </>
                          )}
                        </p>

                        <div className="action-buttons">
                          <button
                            className="edit"
                            onClick={() => handleNavigateEditPage(product)}
                          >
                            {t("edit")}
                          </button>

                          <button
                            className="delete"
                            onClick={() => handleDelete(product._id)}
                          >
                            {t("delete")}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default My_ads;
